import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { DocumentsHelper } from "../../PortfolioDashboard/Components/Document/Resource/DocumentsHelper";
import { DocumentTaskRequestTypeEnum } from "../../../../../../Wrap/Constants/Enums/Tasks/DocumentTaskRequestTypeEnum";
import { processTypeEnum } from "../../Common/Resource/Contents";
import { DownloadButton } from "../../../../../Shared/DownloadButton/DownloadButton";
interface IDocumentProps extends IProcessComponentProps {}

interface IDocumentState {}

export class Document extends ProcessComponent<IDocumentProps, IDocumentState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        return (
            <>
                <h4 className="h4 mr-10">Documents</h4>
                {this.renderDocuments()}
                <br />
            </>
        );
    }

    private renderDocuments() {
        const customerid = getQueryParameters()["customerid"];
        const claccountid = getQueryParameters()["claccountid"];
        const instructionId = getQueryParameters()["id"];
        const headAccountHierarchyId = getQueryParameters()["hierarchyid"];

        const chargesSummaryQuery = DocumentsHelper.getTaskRequest(
            instructionId,
            customerid,
            claccountid,
            headAccountHierarchyId,
            DocumentTaskRequestTypeEnum.ChargeSummary,
            processTypeEnum.WhatIfTool
        );

        return (
            <>
                <div className="mb-24">
                    <a className="hyperlink">Charges Summary</a>
                    <DownloadButton
                        request={chargesSummaryQuery}
                        selectedAccount={headAccountHierarchyId}
                    ></DownloadButton>
                </div>
            </>
        );
    }
}
